export default __webpack_public_path__ + "static/test-image-75ef587dffe15014b80a4d7ba57ac5b9.png";